<div class="container-fluid">
    <div class="row">
      <!-- <div class="col-sm-2">
        <app-invoicing-menu-component></app-invoicing-menu-component>
      </div> -->
      <div class="col-sm-12">
        <router-outlet></router-outlet>
      </div>
    </div>
</div>  